import { Icon } from '@lib/components'

import styles from './styles.module.scss'
import type { FileAttachmentCardProps } from './types'

export const FileAttachmentCard = ({
  displayName,
  fileType,
  iconPath,
  title,
}: FileAttachmentCardProps) => {
  const normalizedFileType = fileType?.trim().toUpperCase() ?? ''

  return (
    <div className={styles.fileAttachmentCard}>
      <div
        className={styles.fileIcon}
        data-extension={normalizedFileType}
      >
        <Icon path={iconPath} />
      </div>
      <div className={styles.fileDescription}>
        <div className={styles.fileName} title={title}>
          {displayName}
        </div>
        <div className={styles.fileExtension}>{normalizedFileType}</div>
      </div>
    </div>
  )
}
